import script from "./ProjectDetailsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectDetailsPage.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectDetailsPage.vue?vue&type=style&index=0&id=dcbe2250&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcbe2250"]])

export default __exports__